import React from "react";
import { ParagraphGroup } from "../paragraph-group";
import boundClasses from "classnames/bind";
import style from "./style.module.css";

export interface ImageTextPairProps {
    imgSrc: string;
    body: string;
    goofy?: boolean;
    title?: string;
    altText?: string;
    groupStyle?: string;
}

export function ImageTextPair(props: ImageTextPairProps) {
    const imageTextClass = boundClasses(
        { [style.imageTextPair]: true },
        { [style.goofy]: props.goofy }
    )
    return (
        <section className={imageTextClass}>
            <ParagraphGroup
                title={props.title}
                body={[props.body]}
                groupStyle={style.paragraphGroup}
            />
            <img
                className={style.image}
                src={props.imgSrc}
                alt={props.altText}
            />
        </section>
    )
}